import { Box } from "@mui/material";
import TestCanvasBoard from "./TestCanvasBoard";
import TestCanvasScattered from "./TestCanvasScattered";

/** Copy of pages jigsaw CanvasScatteredPair for admin canvas tests. */
export default function TestCanvasScatteredPair({
    boardRef,
    boardPieces,
    scatteredRef,
    piecesNotOnBoard,
    scatterPositions,
    grid,
    imageUrl,
    paths,
    svgPathFallback,
    dragging,
    showBoardDragOutline,
    placedCount,
    total,
    isSolved,
    onResetBoard,
    onBoardPieceMouseDown,
    onScatteredPieceMouseDown,
    showPieceGridCoords = true,
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 2,
                width: "fit-content",
                maxWidth: "100%",
                alignItems: "flex-start",
            }}
        >
            <TestCanvasScattered
                scatteredRef={scatteredRef}
                piecesNotOnBoard={piecesNotOnBoard}
                scatterPositions={scatterPositions}
                grid={grid}
                imageUrl={imageUrl}
                paths={paths}
                dragging={dragging}
                showPieceGridCoords={showPieceGridCoords}
                onScatteredPieceMouseDown={onScatteredPieceMouseDown}
            />
            <TestCanvasBoard
                boardRef={boardRef}
                boardPieces={boardPieces}
                grid={grid}
                imageUrl={imageUrl}
                paths={paths}
                svgPathFallback={svgPathFallback}
                dragging={dragging}
                showDragOutline={showBoardDragOutline}
                headerTitle="Scattered board"
                placedCount={placedCount}
                total={total}
                isSolved={isSolved}
                onReset={onResetBoard}
                showPieceGridCoords={showPieceGridCoords}
                onBoardPieceMouseDown={onBoardPieceMouseDown}
            />
        </Box>
    );
}
